<template>
  <div class="buyflow-panel">
      <div v-if="mobileEligible"
          class="desktop:grid grid-cols-12 gap-6">
              <img src="/assets/images/buyflow/woman-looking-at-phone.png" class="col-span-3 widescreen:col-span-2 max-w-1/2 mx-auto desktop:max-w-full h-36 widescreen:h-28 object-cover desktop:ml-0" alt="">
          <div class="desktop:col-span-9  widescreen:col-span-10 flex flex-col tablet:flex-row items-center justify-between gap-4">
              <div class="pr-4">
                  <h2 v-if="!mobileInterested" class="text-sm text-blue uppercase">New</h2>
                  <h2 class="leading-tight text-xl">Save up to $10/mo with Breezeline Mobile</h2>
                  <p v-if="mobileInterested">Breezeline Mobile is available exclusively to Breezeline Internet customers. Finalize your mobile service after you complete your internet order. </p>
                  <p v-else>Clicking Add to plan will allow you to customize your mobile service after finalizing your Internet order with no obligation to buy.</p>
              </div>
              <div v-if="!mobileInterested" class="flex flex-col mt-4 desktop:mt-0 justify-end desktop:pr-4 flex-shrink-0">
                  <button class="buyflow-button flex items-center text-center" @click="addToPlan">{{ buttonText }}</button>
                  <AppModal>
                      <template #trigger>
                          <button
                              class="underline font-bold mt-3 m-auto w-full"
                              @click="viewMoreDetails" >
                              Learn More
                          </button>
                      </template>
                      <template #contents>
                          <div class="text-base text-left font-bold mb-2">
                              Why Choose Breezeline Mobile?
                          </div>
                          <div class="text-sm text-left font-normal break-words">
                              <p>
                                  Breezeline Internet customers can bundle their service and unlock exclusive discounts up to $10/mo.
                                  Just bring your phone, switch to Breezeline Mobile and take your savings to the next level.
                                  No need to learn a phone, Breezeline Mobile makes connecting a breeze. Hassle-free mobile awaits with plans that include:
                              </p>
                              <ul class="mt-4 list-disc list-inside">
                                  <li>Unlimited Talk and Text</li>
                                  <li>Reliable nationwide coverage</li>
                                  <li>Exclusive discounts for Breezeline Internet customers, bundle and save</li>
                                  <li>Data options for everyone in your family to mix and match - get just what you need for each&nbsp;line</li>
                                  <li>Pay the same per line for each plan no matter how many lines you add</li>
                                  <li>Great International roaming and calling rates, for staying connected at home and&nbsp;abroad.</li>
                                  <li>24/7 customer service from the company you can trust</li>
                              </ul>
                              <p class="mt-4">
                                  Choose affordability, not excess and get reliable mobile connectivity when you’re on the go.
                              </p>
                          </div>
                      </template>
                  </AppModal>
              </div>
          </div>
      </div>
      <div v-else-if="fromMobileLP"
           class="desktop:grid grid-cols-12 gap-6">
          <img src="/assets/images/buyflow/woman-looking-at-phone.png" class="col-span-3 widescreen:col-span-2 max-w-1/2 mx-auto desktop:max-w-full h-36 widescreen:h-28 object-cover desktop:ml-0" alt="">
          <div class="desktop:col-span-9  widescreen:col-span-10 flex flex-col tablet:flex-row items-center justify-between gap-4">
              <div class="pr-4">
                  <h3 class="leading-tight text-xl">Thanks for your interest in Breezeline Mobile!</h3>
                  <p>Complete your Internet order and we’ll notify you when mobile is available so you can start saving up to $10/mo on your Internet & TV service.</p>
              </div>
              <div v-if="!mobileInterested" class="flex flex-col mt-4 desktop:mt-0 justify-end desktop:pr-4">
                  <button class="buyflow-button flex items-center text-center" @click="showInterest">{{ interestText }}</button>
              </div>
          </div>
      </div>
      <div v-else
          class="desktop:grid grid-cols-12 gap-6">
          <img src="/assets/images/buyflow/woman-looking-at-phone.png" class="col-span-3 widescreen:col-span-2 max-w-1/2 mx-auto desktop:max-w-full h-36 widescreen:h-28 object-cover desktop:ml-0" alt="">
          <div class="desktop:col-span-9  widescreen:col-span-10 flex flex-col tablet:flex-row items-center justify-between gap-4">
              <div class="pr-4">
                  <h3 class="leading-tight text-xl mb-2">Coming Soon: Breezeline Mobile</h3>
                  <p v-if="mobileInterested">Save up to $10/mo on your Internet & TV service. Complete your internet order and we’ll notify you when mobile is available.</p>
                  <p v-else>Save up to $10/mo on your Internet & TV service with Breezeline Mobile. Sign up to be notified when it is available in your area.</p>
              </div>
              <div v-if="!mobileInterested" class="flex flex-col mt-4 desktop:mt-0 justify-end desktop:pr-4">
                  <button class="buyflow-button flex items-center text-center" @click="showInterest">{{ interestText }}</button>
                  <AppModal>
                      <template #trigger>
                          <button
                              class="underline font-bold mt-3 m-auto w-full"
                              @click="viewMoreDetails">
                              Learn More
                          </button>
                      </template>
                      <template #contents>
                          <div class="text-base text-left font-bold mb-2">
                              Why Choose Breezeline Mobile?
                          </div>
                          <div class="text-sm text-left font-normal break-words">
                              <p>
                                  Breezeline Internet customers can bundle their service and unlock exclusive discounts up to $10/mo.
                                  Just bring your phone, switch to Breezeline Mobile and take your savings to the next level.
                                  No need to learn a phone, Breezeline Mobile makes connecting a breeze. Hassle-free mobile awaits with plans that include:
                              </p>
                              <ul class="mt-4 list-disc list-inside">
                                  <li>Unlimited Talk and Text</li>
                                  <li>Reliable nationwide coverage</li>
                                  <li>Exclusive discounts for Breezeline Internet customers, bundle and save</li>
                                  <li>Data options for everyone in your family to mix and match - get just what you need for each&nbsp;line</li>
                                  <li>Pay the same per line for each plan no matter how many lines you add</li>
                                  <li>Great International roaming and calling rates, for staying connected at home and&nbsp;abroad.</li>
                                  <li>24/7 customer service from the company you can trust</li>
                              </ul>
                              <p class="mt-4">
                                  Choose affordability, not excess and get reliable mobile connectivity when you’re on the go.
                              </p>
                          </div>
                      </template>
                  </AppModal>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import AppModal from "~/Buyflow/components/AppModal"
import IconCircleInfo from "@/atoms/icons/IconCircleInfo"
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'InternetMobileCallout',
    components: {
        AppModal,
        IconCircleInfo
    },
    computed: {
        ...mapState({
            fromMobileLP: state => state.Buyflow.fromMobileLP,
            mobileEligible: state => state.Buyflow.mobileEligible,
			mobileInterested: state => state.Buyflow.mobileInterested,
        }),
		buttonText() {
			return this.mobileEligible && this.mobileInterested ? 'Selected' : 'Add to plan'
		},
		interestText() {
			return !this.mobileEligible && !this.mobileInterested ? 'I\'m interested' : 'Notified'
		}
    },
    methods: {
        ...mapActions({
            setMobileEligibility: 'Buyflow/setMobileEligibility',
            setMobileInterested: 'Buyflow/setMobileInterested',
        }),
        addToPlan() {
            this.setMobileInterested(!this.mobileInterested)
            // Choose the appropriate event based on the toggle state
            const mobilePlanEvent = !this.mobileInterested && this.mobileEligible
                ? 'mobile_eligible_remove_mobile_cta'
                : 'mobile_eligible_add_mobile_cta'

            this.sendEvent('resi:checkout', null, null, mobilePlanEvent)
        },
        showInterest() {
            this.setMobileInterested(!this.mobileInterested)
            this.sendEvent('resi:checkout', null, null, 'checkout_mobile_ineligible_cta')
        },
        viewMoreDetails() {
            if (this.mobileEligible) {
                this.sendEvent('resi:checkout', null, null, 'checkout_mobile_eligible_learn_more')
            } else {
                this.sendEvent('resi:checkout', null, null, 'checkout_mobile_ineligible_learn_more')
            }
        },
    },
}
</script>
